<template>
  <div ref="winner" class="winner">
    <table>
      <tr>
        <th>Ngày quay	</th>
        <th>Mã trúng thưởng	</th>
        <th>Di động</th>
      </tr>
      <tr v-for="item in list" :key="item.number">
        <td>{{ item.date }}</td>
        <td>{{ item.number }}</td>
        <td>{{ item.tel }}</td>
      </tr>

    </table>
  </div>
</template>
<script>
export default {
  name: "winner",
  data() {
    return {
      list: [
        {date:'1/07/2019',number:'934250',tel:'0364***009'},
        // {date:'27/05/2019',number:'518610',tel:'0982***428'},
        // {date:'20/05/2019',number:'056512',tel:'0974***266'},
        // {date:'13/05/2019',number:'330475',tel:'0829***098'},
        // {date:'6/5/2019',number:'068029',tel:'0972***769'},
        // {date:'29/04/2019',number:'714196',tel:'0354***466'},
        // {date:'22/04/2019',number:'013099',tel:'0938***495'},
        // {date:'15/04/2019',number:'891000',tel:'0938***588'},
        // {date:'8/4/2019',number:'439805',tel:'0989***339'},
        // {date:'1/4/2019',number:'383803',tel:'0943***089'},
        // {date:'25/03/2019',number:'241228',tel:'0389***584'},
        // {date:'18/03/2019',number:'516760',tel:'0342***043'},
        // {date:'11/3/2019',number:'745185',tel:'0396***832'},
        // {date:'4/3/2019',number:'775310',tel:'0393***290'},
        // {date:'25/02/2019',number:'432156',tel:'0945***220'},
        // {date:'18/02/2019',number:'999119',tel:'0983***417'},
        // {date:'11/2/2019',number:'860245',tel:'0326***753'},
        // {date:'4/2/2019',number:'603918',tel:'0353***367'},
        // {date:'28/01/2019',number:'649307',tel:'0835***307'},
        // {date:'21/01/2019',number:'194963',tel:'0974***407'},
        // {date:'14/01/2019',number:'021420',tel:'0944***121'},
        // {date:'7/1/2019',number:'334781',tel:'0926***665'},
        // {date:'31/12/2018',number:'587766',tel:'0967***383'},
        // {date:'24/12/2018',number:'258800',tel:'0866***435'},
        // {date:'17/12/2018',number:'387996',tel:'0788***898'},
        // {date:'10/12/2018',number:'116279',tel:'0336***631'},
        // {date:'3/12/2018',number:'182450',tel:'0969***830'},
        // {date:'26/11/2018',number:'499324',tel:'0332***475'},
        // {date:'19/11/2018',number:'977803',tel:'0981***281'},
        // { date:'12/11/2018',number:'567054',tel:'0338***517'},
      ]
    }
  },
  mounted () {
    this.$refs.winner.style.minHeight = `calc(100vh - ${document.querySelector('header').offsetHeight + document.querySelector('footer').offsetHeight}px)`
  },
};
</script>
<style scoped>
.winner {
  position: relative;
  display: block;
  padding: 20px;
  text-align: center;
}

.winner table {
  min-width: 500px;
  width: 60%;
  margin: 0 auto;
}
.winner table th {
  padding: 10px 0;
}
.winner table td {
  padding: 10px 0;
  border-top: 1px solid #ccc;
}
</style>





// WEBPACK FOOTER //
// Winner.vue?575b6cb2